/**
 * https://github.com/JALBAA/vue-lazyload-img
 * 图片懒加载
 * 使用方法: <img v-lazyload="src" />
 */

abstract class ImageElement extends HTMLImageElement {
	newSrc?: string;
	__scrollListener__?: Function;
	__scrollEndListener__?: Function;
}

let cid: number = 0;
class Set {
	private _map: { [cid: number]: any };
	constructor () {
		this._map = {};
	}
	add (obj: any) {
		obj.__cid__ = cid;
		cid++;
		this._map[obj.__cid__] = obj;
	}
	delete (obj: any) {
		if (obj && obj.__cid__ && this._map.hasOwnProperty(obj.__cid__)) delete this._map[obj.__cid__];
	}
	forEach (cb: Function) {
		for (let key in this._map) {
			if (this._map.hasOwnProperty(key)) {
				cb(this._map[key]);
			}
		}
	}
}

const scrollListeners = new Set();
const scrollEndListeners = new Set();
const screenHeight = document.documentElement;

window.addEventListener(
	'scroll',
	function (e: any){
		scrollListeners.forEach((listener: Function) => {
			listener();
		});
	},
	true,
);

window.addEventListener(
	'scrollEnd',
	function (e: any){
		scrollEndListeners.forEach((listener: Function) => {
			listener();
		});
	},
	true,
);

const compute = function (el: ImageElement, time: number, preload: number = 0, cb: Function = function (){}){
	const rect = el.getBoundingClientRect();
	if (
		((rect.bottom >= 0 - preload && rect.bottom <= window.screen.height + preload) ||
			(rect.top >= 0 - preload && rect.top <= window.screen.height + preload)) &&
		((rect.right >= 0 && rect.right <= window.screen.width) || (rect.left >= 0 && rect.left <= window.screen.width))
	) {
		if (el.src != el.newSrc && !!el.newSrc) {
			el.src = el.newSrc;
			el.onload = function (){
				el.style.opacity = '1';
				el.onload = function (){};
				scrollListeners.delete(el.__scrollListener__);
				scrollEndListeners.delete(el.__scrollEndListener__);
				(el as any).__scrollListener__ = null;
				(el as any).__scrollEndListener__ = null;
			};
			el.style.transition = `opacity ${time}ms`;
			cb();
		}
	}
};
type GetSpeedArgs = {
	lastPos: number;
	lastSpeeds: Array<number>;
	aveSpeed: number;
};
const getSpeed = function ({ lastPos, lastSpeeds, aveSpeed }: GetSpeedArgs){
	const clientRect = document.body.getBoundingClientRect();
	const curPos = clientRect.top;
	// const curPos = document.body.getBoundingClientRect().top
	let speed = lastPos - curPos;
	if (lastSpeeds.length < 10) {
		lastSpeeds.push(speed);
	} else {
		lastSpeeds.shift();
		lastSpeeds.push(speed);
	}
	let sumSpeed = 0;
	lastSpeeds.forEach(function (speed: number){
		sumSpeed += speed;
	});
	aveSpeed = Math.abs(sumSpeed / lastSpeeds.length);
	lastPos = curPos;
	return {
		lastPos,
		lastSpeeds,
		aveSpeed,
	};
};

abstract class ScrollEvent extends Event {
	eventType?: string;
}
const scrollEnd = function (){
	let cntr = 0;
	let lastCntr = 0;
	let diff = 0;
	const scrollEnd = document.createEvent('HTMLEvents') as ScrollEvent;
	scrollEnd.initEvent('scrollEnd', true, false);
	scrollEnd.eventType = 'message';
	function enterFrame (){
		if (cntr !== lastCntr) {
			diff++;
			if (diff === 5) {
				window.dispatchEvent(scrollEnd);
				cntr = lastCntr;
			}
		}
		requestAnimationFrame(enterFrame);
	}
	window.requestAnimationFrame(enterFrame);
	window.addEventListener('scroll', () => {
		lastCntr = cntr;
		diff = 0;
		cntr++;
	});
};

let time: number = 300;
let speed: number = 0;
let preload: number = 0;

export default {
	bind (el: ImageElement, binding: any, vnode: any) {
		if (!el.src.replace(/^https?:/, '').match(binding.value.replace(/^https?:/, ''))) return;
		el.newSrc = binding.value;
		el.style.opacity = '0';

		let speedInfo: GetSpeedArgs = {
			lastPos: document.body.getBoundingClientRect().top,
			lastSpeeds: [],
			aveSpeed: 0,
		};
		const computeBySpeed = function (){
			if (!el.newSrc || el.newSrc === el.src) return;
			if (speed == 0) {
				compute(el, time, preload);
				return;
			}
			speedInfo = getSpeed(speedInfo) as GetSpeedArgs;
			if (speedInfo.aveSpeed > speed) return;
			compute(el, time, preload);
		};
		const onScrollEnd = function (){
			if (!el.newSrc || el.newSrc === el.src) return;
			compute(el, time, preload);
		};
		const onError = function (){
			el.onload = function (){};
			el.removeEventListener('error', onError);
			scrollListeners.delete(computeBySpeed);
			scrollEndListeners.delete(onScrollEnd);
		};
		el.__scrollListener__ = computeBySpeed;
		el.__scrollEndListener__ = onScrollEnd;
		el.addEventListener('error', onError);
		el.onload = function (){
			el.onload = function (){};
			el.removeEventListener('error', onError);
			compute(el, time, preload);
			scrollListeners.add(computeBySpeed);
			if (speed > 0) scrollEndListeners.add(onScrollEnd);
		};
	},
	update (el: ImageElement, binding: any, vnode: any) {
		if (!el.src.replace(/^https?:/, '').match(binding.value.replace(/^https?:/, ''))) return;
		el.style.opacity = '0';
		el.style.transition = `opacity ${time / 2}ms`;
		el.newSrc = binding.value;
		setTimeout(() => {
			compute(el, time / 2, preload);
		}, 150);
	},
	unbind (el: ImageElement, binding: any, vnode: any) {},
};
